import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShoppingBag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconShoppingBag2"><Path fillRule="evenodd" clipRule="evenodd" d="M8.00146 6C8.00146 3.79086 9.79233 2 12.0015 2C14.2106 2 16.0015 3.79086 16.0015 6V7H16.8887C17.7561 7 18.4927 7.63546 18.6198 8.49354L20.3235 19.9935C20.4801 21.0506 19.661 22 18.5924 22H5.41051C4.34189 22 3.5228 21.0506 3.6794 19.9935L5.3831 8.49354C5.51023 7.63546 6.24676 7 7.11421 7H8.00146V6ZM9.50146 7H14.5015V6C14.5015 4.61929 13.3822 3.5 12.0015 3.5C10.6208 3.5 9.50146 4.61929 9.50146 6V7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShoppingBag2;
